import * as React from "react"
const AnnotationSVG = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
			<path
				fill="#475163"
				d="M8 18v-2h2v2H8ZM8 2V0h2v2H8Zm4 16v-2h2v2h-2Zm0-16V0h2v2h-2Zm4 12v-2h2v2h-2Zm0-4V8h2v2h-2Zm0-4V4h2v2h-2ZM2 16V2H1a.968.968 0 0 1-.713-.288A.964.964 0 0 1 0 1C0 .717.096.479.288.287A.964.964 0 0 1 1 0h4c.283 0 .521.096.713.288.192.192.288.43.287.712a.968.968 0 0 1-.288.713A.964.964 0 0 1 5 2H4v14h1c.283 0 .521.096.713.288.192.192.288.43.287.712a.968.968 0 0 1-.288.713A.964.964 0 0 1 5 18H1a.968.968 0 0 1-.713-.288A.964.964 0 0 1 0 17c0-.283.096-.521.288-.713A.964.964 0 0 1 1 16h1ZM16 2V0c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412h-2Zm0 16v-2h2c0 .55-.196 1.021-.588 1.413A1.922 1.922 0 0 1 16 18Z"
			/>
		</svg>
	)
}

export default AnnotationSVG
